import React from 'react'
import styled, { css } from 'styled-components'
import { colors, media } from '../styles/vars'
import { Link } from 'react-router-dom'
import { Link as ScrollLink } from 'react-scroll'
import navItems from '../data/nav-items.json'
const Container = styled.li`
display:${props => props.hideScrollLink && props.isScroller ? 'none' : 'block'};
font-size:2.2rem;
padding:6px 0;
&:not(:last-child){
    margin-bottom:25px;
}

${
    media.desktop`
    font-size:1.8rem;
    transition:color .2s, font-size .2s;
    &:hover{
        color:${colors.red};
        font-size:2rem;
    }
 `
    }
`
const linkCss = css`
display:block;
&, &:visited, &:hover{
    color:${colors.white};
    text-decoration:none;
}
&, > label{
    cursor:pointer;
}
`
const Anchor = styled(Link) `
${linkCss}
`
const TargetLink = styled(ScrollLink) `
${linkCss}
`

const NavItem = (props) => {
    const generateLink = () => {
        if (props.type === 'scroller') {
            if (props.noScroll) {
                return <Anchor
                    onClick={props.onClick}
                    to={`/${props.target}`} replace>
                    <label>{props.title}</label>
                </Anchor>
            }
            let offset = -100;
            const sectionData = navItems.find(item => item.target === props.target);
            if (sectionData && sectionData.offset && sectionData.mobOffset)
                offset = sectionData[props.isMobile ? 'mobOffset' : 'offset'];
            return <TargetLink
                onClick={props.onClick}
                to={props.target}
                smooth={true}
                duration={500}
                offset={offset}
            >
                <label>{props.title}</label>
            </TargetLink>
        }
        return <Anchor
            onClick={props.onClick}
            to={props.href}
            replace>
            <label>{props.title}</label>
        </Anchor>
    }
    return (
        <Container>
            {generateLink()}
        </Container>
    )
}

export default NavItem;


// WEBPACK FOOTER //
// ./src/components/NavItem.jsx